<template>
  <el-container class="f-h">
    <el-header class="sub-header" style="height: 3rem">
      <el-row type="flex" justify="space-between">
        <span class="sub-title">
          <slot name="title">{{ title }}</slot>
        </span>
        <div>
          <span v-for="param in params" :key="param.code">
            <span v-if="param.inputType == '标签'">{{ condition[param.code] }}</span>
            <el-date-picker v-else-if="param.inputType == '日期'" v-model="condition[param.code]" size="small" class="condition-input" :placeholder="param.name" value-format="yyyy-MM-dd" clearable @change="exec" @clear="exec" />
            <el-time-picker v-else-if="param.inputType == '时间'" v-model="condition[param.code]" size="small" class="condition-input" :placeholder="param.name" value-format="HH:mm:ss" clearable @change="exec" @clear="exec" />
            <hic-dict-selector v-else-if="param.inputType == '单选' && param.valueType == '字典'" v-model="condition[param.code]" size="small" :dict-type="param.dict" class="condition-input" :placeholder="param.name" clearable @change="exec" @clear="exec" />
            <el-select v-else-if="param.inputType == '单选' && param.valueType == '报表'" v-model="condition[param.code]" size="small" :placeholder="param.name" clearable @change="exec" @clear="exec">
              <el-option v-for="o in rpt[p.dict]" :key="o.code" :label="o.text" :value="o.code"></el-option>
            </el-select>
            <el-input v-else v-model="condition[param.code]" size="small" class="condition-wide" :placeholder="param.name" clearable @keydown.enter.native="exec" @clear="exec" />
          </span>
          <el-button v-if="value && value.code" type="primary" size="small" plain @click="exec" icon="el-icon-search" class="left-pad" :loading="loading">查询</el-button>
          <el-button v-if="value && value.printTmpl" type="warning" size="small" plain @click="print" icon="el-icon-printer" class="left-pad">打印</el-button>
          <!-- <el-dropdown split-button type="default" @click="download" @command="print" size="small" class="left-pad" :loading="loading">
            <i class="el-icon-download" /> 导出
            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item v-if="value && value.printTmpl"><i class="el-icon-printer" />打印</el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown> -->
        </div>
      </el-row>
    </el-header>
    <el-main>
      <el-empty v-if="!value || !value.code" description="没有可以展示的报表，请检查报表配置！" />
      <el-skeleton v-if="loading" :rows="6" animated />
      <el-table v-show="value && value.code && !loading && !errMsg" :data="entities.items" :loading="loading" height="100%" @filter-change="filterChanged" @sort-change="sortChanged" :show-summary="value && value.ifSum" :summary-method="getSum">
        <el-table-column v-for="col in cols" :key="col.code" :label="col.name" :prop="col.code" :sortable="col.sortable ? 'custom' : null" :align="col.type == '整数' || col.type == '小数' ? 'right' : col.type == '日期' || col.type == '时间' ? 'center' : 'left'">
          <template #default="{ row }">
            <span v-if="col.type == '字典'">{{ dictTxt(row[col.code], col.dict) }}</span>
            <span v-else-if="col.type == '小数'">{{ row[col.code] | fmtFloat }}</span>
            <span v-else>{{ row[col.code] }}</span>
          </template>
        </el-table-column>
      </el-table>
      <p v-if="errMsg" class="danger">{{ errMsg }}</p>
      <hic-print-simple v-if="value && value.printTmpl" v-show="false" ref="printer" :tmpl-code="value.printTmpl" :print-data="printData" @ok="printerReady" />
    </el-main>
    <el-footer v-if="value && value.ifPage" class="center">
      <hic-paging :entities="entities" :condition="condition" @load="exec" />
    </el-footer>
  </el-container>
</template>
<script>
  import { apiFuns, mapGetters } from "sw-hic";
  export default {
    name: "hic-report-panel",
    props: {
      value: Object,
    },
    data() {
      return {
        loading: false,
        params: [],
        cols: [],
        entities: {
          items: [],
        },
        condition: {
          pageIndexOnView: 1,
          pageIndex: 0,
          pageSize: 20,
        },
        errMsg: null,
        rptDicts: {},
        sums: { no: "合计" },
        printData: {},
      };
    },
    computed: {
      ...mapGetters(["dict", "user"]),
      title() {
        return this.value?.name;
      },
      dictTypes() {
        let types = [
          {
            code: "Dept",
            text: "科室",
          },
          ...this.rptDicts,
          ...this.dict.DictType,
        ];
        return types;
      },
    },
    watch: {
      "value.code"() {
        this.init();
      },
    },
    mounted() {
      this.init();
    },
    methods: {
      init() {
        if (!this.value?.code) {
          return;
        }
        this.items = [];
        this.params = JSON.parse(this.value.params);
        this.printData = {}
        let con = {
          pageIndex: 0,
          pageSize: 20,
        };
        this.params.forEach((p) => {
          con[p.code] = null;
          if (p.defaultValue) {
            let dft = eval(p.defaultValue);
            if (p.valueType == "文本" || p.valueType == "字典" || p.valueType == "报表") {
              dft = String(dft);
            }
            con[p.code] = dft;
          }
          if (p.valueType == "字典" && p.dict && !this.dict[p.dict]) {
            this.$store.dispatch("loadDicts", p.dict);
          }
          
          // 这里是获取用报表做查询条件
          if (p.valueType == "报表" && !this.rpt[p.dict]) {
            apiFuns
              .post(`/api/report/report/${p.dict}/exec`, {})
              .then((res) => {
                this.rpt[p.dict] = res[0].data;
              })
              .catch((err) => {
                console.log(err);
              });
          }
        });
        apiFuns.get(`/api/report/report`, { type: "字典" }).then((res) => {
          this.rptDicts = res.items.map((i) => ({ code: `rpt_${i.id}`, text: i.name }));
        });
        this.condition = con;
        this.cols = JSON.parse(this.value.cols);
        this.$nextTick(() => {
          this.exec();
        });
      },
      exec() {
        if (this.loading) {
          return;
        }
        this.entities = {
          items: [],
        };
        this.condition.pageIndex = this.condition.pageIndexOnView - 1;
        this.loading = true;
        this.errMsg = null;
        apiFuns
          .post(`/api/report/report/${this.value.id}/exec`, this.condition)
          .then((res) => {
            this.entities = res[0].data;
          })
          .catch((err) => {
            this.errMsg = err;
            console.log(err);
          })
          .finally(() => {
            this.loading = false;
          });
        // 获取合计
        if (this.value?.ifSum) {
          let con = this.$utils.Obj.clone(this.condition);
          con.pageIndex = 0;
          con.pageIndexOnView = 1;
          con.pageSize = 999999;
          this.loading = true;
          apiFuns
            .post(`/api/report/report/${this.value.id}/sum`, con)
            .then((res) => {
              if (res["common_auto_no"]) {
                res.common_auto_no = "合计：";
              } else if (res[this.cols[0].code]) {
                res[this.cols[0].code] = "合计：";
              } else {
                res[Object.keys(res)[0]] = "合计：";
              }
              this.sums = res;
            })
            .catch((err) => {
              console.log(err);
            });
        }
      },
      sortChanged({ prop, order }) {
        this.condition.asc = order === "ascending";
        this.condition.sort = prop;
        this.refresh();
      },
      filterChanged(options) {
        Object.assign(this.condition, options);
        this.refresh();
      },
      refresh() {
        this.condition.pageIndexOnView = 1;
        this.exec();
      },
      // download() {
      //   let con = this.$utils.Obj.clone(this.condition);
      //   con.pageIndex = 0;
      //   con.pageIndexOnView = 1;
      //   con.pageSize = 999999;
      //   this.loading = true;
      //   apiFuns
      //     .post(`/api/report/report/${this.value.id}/exec`, con)
      //     .then((res) => {
      //       import("./exsl/excel").then((excel) => {
      //         let header = this.cols.map((c) => c.name);
      //         if (this.value.ifSum) {
      //           res[0].data.items.push(this.sums);
      //         }
      //         let data = this.formatExcel(res[0].data.items);
      //         excel.export_json_to_excel({
      //           header,
      //           data,
      //           filename: this.title || "数据导出",
      //         });
      //       });
      //     })
      //     .catch((err) => {
      //       this.errMsg = err;
      //       console.log(err);
      //     })
      //     .finally(() => {
      //       this.loading = false;
      //     });
      // },
      // formatExcel(items) {
      //   return items.map((i) => {
      //     return this.cols.map((c) => {
      //       if (c.type == "字典" && c.dict) {
      //         return this.dictTxt(i[c.code], c.dict);
      //       }
      //       if (c.type == "小数") {
      //         return this.$utils.Fmt.float(i[c.code]);
      //       }
      //       return i[c.code];
      //     });
      //   });
      // },
      formatPrintData(items) {
        return items.map((i) => {
          this.cols.forEach((c) => {
            if (c.type == "字典" && c.dict) {
              i[c.code] = this.dictTxt(i[c.code], c.dict);
            }
          });
          return i;
        });
      },
      dictTxt(val, type) {
        if (!val || !type) {
          return val;
        }
        let dict = null;
        if (type.startsWith("rpt_")) {
          const id = type.replace("rpt_", "");
          const rpt = this.rptDicts.find((r) => r.id == id);
          if (rpt) {
            dict = rpt.find((r) => r.code == val);
          }
        } else {
          dict = this.dict[type].find((d) => d.code == val);
        }
        if (dict) {
          return dict.text;
        }
        return val;
      },
      getSum() {
        let arr = [];
        this.cols.forEach((c) => {
          arr.push(this.sums[c.code]);
        });
        return arr;
      },
      print() {
        let con = this.$utils.Obj.clone(this.condition);
        con.pageIndex = 0;
        con.pageIndexOnView = 1;
        con.pageSize = 999999;
        this.loading = true;
        apiFuns
          .post(`/api/report/report/${this.value.id}/exec`, con)
          .then((res) => {
            this.printData = {
              master: {
                user: this.user.name,
                tenant: this.user.tenantName,
                dept: this.user.deptName,
                title: this.value.name,
                ...con,
              },
              detail: this.formatPrintData(res[0].data.items),
              _ready: true,
            };
          })
          .catch((err) => {
            this.errMsg = err;
            console.log(err);
          })
          .finally(() => {
            this.loading = false;
          });
      },
      printerReady() {
        if (!this.printData._ready) {
          return;
        }
        console.log("ready", this.printData);

        this.$refs.printer.preview();
      },
    },
  };
</script>
